import { Select } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";

const FilterModeSelector = ({
  value,
  onChange,
  borderColor,
  disabled,
  level,
}) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Select
      value={value}
      onChange={onChange}
      style={{
        position: "absolute",
        top: "calc(50% + 35px)",
        left: 7,
        transform: "translate(-50%, -50%)",
        zIndex: 5,
      }}
      data={[
        {
          value: "and",
          label: lang.table.toolbar.filter.conditions.and,
        },
        {
          value: "or",
          label: lang.table.toolbar.filter.conditions.or,
        },
      ]}
      comboboxProps={{ zIndex: 1400, offset: 2, shadow: "sm" }}
      w={level === 0 ? 75 : 58}
      size={level === 0 ? "sm" : "xs"}
      styles={{
        input: {
          borderColor,
        },
      }}
      readOnly={disabled}
    />
  );
};

export default FilterModeSelector;
